// Herb categories — MIRRORS the mobile app's TherapeuticUse list
// (sarv-app/src/data/TherapeuticUse.js): same titles, descriptions, images, and
// `subcategories`. The web listing (HerbCategoryList.js) filters herbs exactly
// like the app does: .overlaps("therapeutic_actions", subcategories.map(lowercase)).
// Images live in /public/img/explorer/herbs/ (synced from the app's assets).
const IMG = "/img/explorer/herbs";

const HERB_CATEGORIES = [
  {
    slug: "pain-management",
    name: "Pain Management",
    description: "Herbs that reduce pain and inflammation",
    image: `${IMG}/pain_management.jpg`,
    subcategories: [
      "Analgesic", "Anti-inflammatory", "Antipyretic", "Antispasmodic", "Ntispasmodic",
      "Mild Analgesic", "Anti-asthmatic", "Muscle Relaxant", "Anti-fatigue", "Counterirritant",
    ],
  },
  {
    slug: "digestive-health",
    name: "Digestive Health",
    description: "Herbs that support digestive health and function",
    image: `${IMG}/digestive-health.jpg`,
    subcategories: [
      "Alterative", "Alternative", "Carminative", "Digestive Aid", "Stomachic", "Cholagogue",
      "Aperient", "Laxative", "Mild Laxative", "Cathartic", "Purgative", "Demulcent",
      "Appetite suppressant",
    ],
  },
  {
    slug: "respiratory-health",
    name: "Respiratory Health",
    description: "Herbs that enhance respiratory health",
    image: `${IMG}/respiratory_health.jpg`,
    subcategories: [
      "Expectorant", "Decongestant", "Anticatarrhal", "Mucolytic", "Respiratory Health",
      "Cough Suppressant",
    ],
  },
  {
    slug: "womens-health-and-hormonal-support",
    name: "Women's Health and Hormonal Support",
    description: "Herbs that support women's health and hormonal balance",
    image: `${IMG}/womens_health.jpg`,
    subcategories: ["Emmenagogue", "Parturient", "Galactagogue", "Aphrodisiac", "Menstrual Support"],
  },
  {
    slug: "liver-and-detoxification",
    name: "Liver and Detoxification",
    description: "Herbs that support liver health and detoxification",
    image: `${IMG}/liver_detox.jpg`,
    subcategories: ["Hepatoprotective", "Hepatic", "Detoxifying", "Depurative", "Liver Tonic"],
  },
  {
    slug: "neurological-and-cognitive-health",
    name: "Neurological and Cognitive Health",
    description: "Herbs that support neurological and cognitive functions",
    image: `${IMG}/neuro_health.jpg`,
    subcategories: [
      "Neuroprotective", "Cognitive Enhancer", "Sedative", "Hypnotic", "Migraine Prophylaxis",
      "Sleep Aid", "Nervine", "Anxiolytic", "Mood Enhancer",
    ],
  },
  {
    slug: "skin-and-tissue-health",
    name: "Skin and Tissue Health",
    description: "Herbs that nourish and heal the skin and tissues",
    image: `${IMG}/skin_health.jpg`,
    subcategories: [
      "Emollient", "Vulnerary", "Wound Healing", "Healing",
      "Nourishing to the skin (when used in oils and creams)", "Moisturizing",
      "Promotes Tissue Repair", "Supports Bone and Connective Tissue Health",
    ],
  },
  {
    slug: "antioxidant-support",
    name: "Antioxidant Support",
    description: "Herbs that provide antioxidant benefits",
    image: `${IMG}/antioxidant_support.jpg`,
    subcategories: ["Antioxidant"],
  },
  {
    slug: "urinary-and-kidney-health",
    name: "Urinary and Kidney Health",
    description: "Herbs that promote urinary and kidney health",
    image: `${IMG}/urinary_health.jpg`,
    subcategories: ["Diuretic"],
  },
  {
    slug: "gastrointestinal-health",
    name: "Gastrointestinal Health",
    description: "Herbs that aid in gastrointestinal health and wellness",
    image: `${IMG}/gastro_health.jpg`,
    subcategories: [
      "Carminative", "Digestive Aid", "Stomachic", "Laxative", "Antinausea",
      "Anti-inflammatory", "Antiemetic",
    ],
  },
  {
    slug: "reproductive-health",
    name: "Reproductive Health",
    description: "Herbs that enhance reproductive health and function",
    image: `${IMG}/reproductive_health.jpg`,
    subcategories: ["Aphrodisiac", "Emmenagogue", "Galactagogue", "Parturient"],
  },
  {
    slug: "endocrine-health",
    name: "Endocrine Health",
    description: "Herbs that regulate endocrine activity and blood sugar levels",
    image: `${IMG}/endocrine_health.jpg`,
    subcategories: ["Hypoglycemic", "Blood Sugar Regulating"],
  },
  {
    slug: "mental-and-cognitive-function",
    name: "Mental and Cognitive Function",
    description: "Herbs that enhance mental health and cognitive performance",
    image: `${IMG}/mental_health.jpg`,
    subcategories: [
      "Cognitive Enhancer", "Anxiolytic", "Mood Enhancer", "Sedative", "Hypnotic", "Sleep Aid",
    ],
  },
  {
    slug: "bone-and-joint-health",
    name: "Bone and Joint Health",
    description: "Herbs that support bone and joint health",
    image: `${IMG}/bone_joint_health.jpg`,
    subcategories: ["Anti-inflammatory", "Analgesic"],
  },
  {
    slug: "immune-system-health",
    name: "Immune System Health",
    description: "Herbs that strengthen the immune system",
    image: `${IMG}/immune_health.jpg`,
    subcategories: ["Immunomodulatory", "Antimicrobial", "Antibacterial", "Antiviral"],
  },
  {
    slug: "cancer-prevention",
    name: "Cancer Prevention",
    description: "Herbs that may help in reducing the risk of cancer",
    image: `${IMG}/cancer_prevention.jpg`,
    subcategories: ["Anticancer"],
  },
  {
    slug: "eye-health",
    name: "Eye Health",
    description: "Herbs that support vision and eye health",
    image: `${IMG}/eye_health.jpg`,
    subcategories: ["Antioxidant"],
  },
];

export const getHerbCategory = (slug) =>
  HERB_CATEGORIES.find((c) => c.slug === slug) || null;

export default HERB_CATEGORIES;
